import { 
  Container, 
  SectionHeader, 
  CaseLabel,
  MainTitle,
  TileGrid,
  CaseStudyWrapper,
  VisualPanel,
  VisualTitle,
  Screenshot,
  InfoPanel,
  ProjectName,
  ProjectDesc,
  BulletList,
  Bullet,
  TagCloud,
  Tag
} from './TileStyle';
import { projects } from '../../data/constants';
import { motion } from 'framer-motion';
import { Sparkles, ArrowRight } from 'lucide-react';

const cardVariants = {
  offscreen: {
    y: 150,
    opacity: 0,
    scale: 0.95
  },
  onscreen: (index) => ({
    y: 0,
    opacity: 1,
    scale: 1,
    transition: {
      type: "spring",
      bounce: 0.5,
      duration: 1.2,
      delay: index * 0.15
    },
  }),
};

const CaseStudyCard = ({ project, setOpenModal, index }) => {
  return (
    <CaseStudyWrapper
      as={motion.div}
      custom={index}
      initial="offscreen"
      whileInView="onscreen"
      viewport={{ once: true, margin: "-50px" }}
      variants={cardVariants}
      whileHover={{ y: -10, transition: { type: "spring", stiffness: 300 } }}
    >
      <VisualPanel 
        bgColor={project.bgColor || '#1E1E1E'}
        onClick={() => setOpenModal({ state: true, project: project })}
      >
        <VisualTitle>
          {project.impact || project.description}
          <ArrowRight size={20} style={{ marginLeft: '10px', opacity: 0.6 }} />
        </VisualTitle>
        <Screenshot src={project.image} alt={project.title} />
      </VisualPanel>

      <InfoPanel>
        <ProjectName>{project.title}</ProjectName>
        <ProjectDesc>{project.description}</ProjectDesc>
        
        <BulletList>
          {(project.features || ["Feature mapping and roadmapping", "User research and prototyping", "Agile delivery management"]).map((feature, i) => (
            <Bullet key={i}>
              <Sparkles size={16} />
              <span>{feature}</span>
            </Bullet>
          ))}
        </BulletList>

        <TagCloud>
          {project.tags.map((tag, i) => (
            <Tag key={i}>{tag}</Tag>
          ))}
        </TagCloud>
      </InfoPanel>
    </CaseStudyWrapper>
  );
};

const ProjectTiles = ({ openModal, setOpenModal }) => {
  return (
    <Container id="projects">
      <SectionHeader>
        <CaseLabel>Case Studies</CaseLabel>
        <MainTitle>
          Curated <span>work</span>
        </MainTitle>
      </SectionHeader>

      <TileGrid>
        {projects.map((project, index) => (
          <CaseStudyCard 
            key={project.id} 
            project={project} 
            index={index}
            setOpenModal={setOpenModal} 
          />
        ))}
      </TileGrid>
    </Container>
  );
};

export default ProjectTiles;

